import { tKey, type I18nKey } from "@/core/i18n";
import { ModelBackendEnum, ProjectTypeEnum } from "@repo/schema";

export const TRAINING_TYPE_LABELS = {
  [ProjectTypeEnum.CLASSIFICATION]: tKey("model:trainingType.CLASSIFICATION"),
  [ProjectTypeEnum.DETECTION]: tKey("model:trainingType.DETECTION"),
  [ProjectTypeEnum.SEGMENTATION]: tKey("model:trainingType.SEGMENTATION"),
} satisfies Record<ProjectTypeEnum, I18nKey<"model">>;

/** The raw enum spelling, for places that have always shown `DETECTION` rather than a label. */
export const TRAINING_TYPE_VALUES = {
  [ProjectTypeEnum.CLASSIFICATION]: tKey("model:trainingTypeValue.CLASSIFICATION"),
  [ProjectTypeEnum.DETECTION]: tKey("model:trainingTypeValue.DETECTION"),
  [ProjectTypeEnum.SEGMENTATION]: tKey("model:trainingTypeValue.SEGMENTATION"),
} satisfies Record<ProjectTypeEnum, I18nKey<"model">>;

// Ultra Vision is the only backend new models can use. The other three are only
// ever seen on models trained before the switch, hence the "legacy" marker —
// they stay viewable, convertible and deployable, but cannot be retrained.
export const BACKEND_LABELS = {
  [ModelBackendEnum.ULTRA_VISION]: tKey("model:backend.ULTRA_VISION"),
  [ModelBackendEnum.ULTRALYTICS]: tKey("model:backend.ULTRALYTICS"),
  [ModelBackendEnum.RF_DETR]: tKey("model:backend.RF_DETR"),
  [ModelBackendEnum.LUXONIS]: tKey("model:backend.LUXONIS"),
} satisfies Record<ModelBackendEnum, I18nKey<"model">>;
